<template src="./EditPayment.html"></template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import { getPayment, updatePayment, removePaymentServices } from '../../../services'
import {
  formatDateUTC,
  getStatusServiceChip,
  getServiceStatus
} from '../../../utils/computeds'
import { SERVICE_STATUS } from '../../../utils/constants'
import { isVisitService } from '../../../utils'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
  name: 'EditPayment',
  data () {
    return {
      SERVICE_STATUS,
      payment: {},
      menuUpdate: false,
      services: [],
      checkedAll: false,
      servicesChecked: []
    }
  },
  validations () {
    return {
      payment: {
        paymentDate: { required },
        invoiceNumber: { required },
        total: { required }
      }
    }
  },
  created () {
    this.loadPayment(this.$route.params.id)
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    async loadPayment (paymentId) {
      try {
        const { payment, services } = await getPayment(paymentId)
        this.services = services || []
        this.payment = payment
        this.payment.paymentDate = moment.utc(this.payment.paymentDate).format('YYYY-MM-DD')
        this.payment.total = Math.round(parseFloat(this.payment.total))
      } catch (error) {
        console.log('Error on get payment =>', error)
        this.$swal({
          text: error.message ?? 'Ocurrió un error al cargar el pago.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },
    async update () {
      try {
        const payload = {
          invoiceNumber: this.payment.invoiceNumber,
          paymentDate: this.payment.paymentDate,
          total: this.payment.total,
          observation: this.payment.observation || ''
        }
        await updatePayment(this.payment.id, payload)
        await this.loadPayment(this.payment.id)
        this.$swal({
          text: 'Se actualizó el pago.',
          buttons: false,
          icon: 'success',
          timer: 3000
        })
      } catch (error) {
        console.log('Error on update payment =>', error)
        this.$swal({
          text: error.message ?? 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    },
    formatDate (date) {
      if (!date) return ''
      const d = new Date(date)
      return d.toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })
    },
    check (e, service) {
      e.cancelBubble = true
      this.checkedAll = false

      if (this.servicesChecked.includes(service.id)) {
        this.servicesChecked = this.servicesChecked.filter(
          (serviceId) => serviceId !== service.id
        )
        service.checked = false
      } else {
        this.servicesChecked.push(service.id)
        service.checked = true
      }
    },
    checkAll (e) {
      e.cancelBubble = true

      if (!this.checkedAll) this.servicesChecked = []
      else this.servicesChecked = this.services.map((service) => service.id)

      for (const service of this.services) {
        service.checked = this.checkedAll
      }
    },
    ifDeleteServices () {
      this.$swal({
        title: `¿Estás seguro de eliminar los ${this.servicesChecked.length} servicios?`,
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((value) => {
        if (value) {
          this.deleteServices()
        }
      })
    },
    downloadExcel () {
      const services = this.services.filter((service) => this.servicesChecked.includes(service.id))
      // Viáticos go only on the process's visit service row, same rule as the payment total.
      const viaticosShownForProcessId = new Set()
      const jsonData = services.map((service) => {
        const processId = service.process?.id
        const processExtraCost = Number(service.process?.extraCost) || 0
        let viaticos = 0
        if (isVisitService(service) && processExtraCost > 0 && processId != null && !viaticosShownForProcessId.has(processId)) {
          viaticos = processExtraCost
          viaticosShownForProcessId.add(processId)
        }
        return {
          'Cliente': service.process.company.name,
          'NIT': service.process.company.nit,
          'Evaluado': service.process.evaluated.fullName,
          'Documento Evaluado': service.process.evaluated.documentId,
          'Servicio': service.name,
          'Fecha Asignado': this.formatDate(service.createdAt),
          'Fecha de Finalización': this.formatDate(service.process.finalizedAt),
          'Observación': service.observation,
          'Estado': this.getServiceStatus(service.status),
          'Costo': service.cost,
          'Valor': service.value,
          'Viáticos': viaticos
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(jsonData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Servicios')

      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      })
      const data = new Blob([excelBuffer], { type: 'application/octet-stream' })
      saveAs(data, `Servicios pago ${this.payment.invoiceNumber}.xlsx`)
    },
    async deleteServices () {
      try {
        await removePaymentServices(this.payment.id, this.servicesChecked)
        await this.loadPayment(this.payment.id)
        this.checkedAll = false
        this.$swal({
            text: `Se eliminaron los ${this.servicesChecked.length} servicios del pago.`,
            buttons: false,
            icon: 'success',
            timer: 3000
        })
        this.servicesChecked = []
      } catch (error) {
        console.log('Error on remove services from payment =>', error)
        this.$swal({
          text: 'Ocurrió un error, intenta más tarde.',
          buttons: false,
          icon: 'error',
          timer: 3000
        })
      }
    }
  },
  computed: {
    formatDateUTC,
    getStatusServiceChip,
    getServiceStatus
  }
}
</script>

<style src="./EditPayment.scss" lang="scss"></style>
